// mui
import { Grid, Typography, Paper, GridProps } from '@mui/material';
import { ReactNode } from 'react';

// props
export interface Detail {
	GridProps?: GridProps;
	label: ReactNode;
	value: ReactNode;
}
export interface CardDetailsProps {
	data: Detail[];
}

export const CardDetails = ({ data }: CardDetailsProps) => {
	return (
		<Paper
			sx={(theme) => {
				return {
					padding: theme.spacing(2),
					[theme.breakpoints.up('md')]: {
						padding: theme.spacing(3),
					},
					height: '100%',
				};
			}}>
			<Grid container spacing={4}>
				{data.map((item) => {
					const { GridProps, label, value } = item;
					return (
						<Grid item xs={6} md={4} key={`card-details-${label}`} {...GridProps}>
							{typeof label === 'string' ? (
								<Typography variant="h3" color="brand.grey.500">
									{label}
								</Typography>
							) : (
								label
							)}
							{typeof value === 'string' ? <Typography>{value}</Typography> : value}
						</Grid>
					);
				})}
			</Grid>
		</Paper>
	);
};
